module.exports = __webpack_public_path__ + "Octopus-96x96.0701d7ff661133eafb2bbd23656eb7db.hashedasset.png";